import "babel-polyfill";
import Vue from 'vue';
// import ShareVip from '../views/share-vip'
// import i18n from '../i18n/vip/index'
import RichPrivacyPolicy from '../views/rich-privacypolicy'
import '../assets/css/style.css'
// import Message from '../components/Message/index'
// Vue.use(Message)
new Vue({
  // router,
  // store,
  // i18n,
  render: h => h(RichPrivacyPolicy)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/entry/rich-privacypolicy.js